import {canUseDOM} from '../canUseDOM';

export const isProdEnvironment = () => {
    if (!canUseDOM) return true;

    return window.location.hostname === 'a-bank.com.ua';
};

export const filterByEnvironment = items => {
    if (!items) return [];
    const isProd = isProdEnvironment();
    return items.filter(item => (isProd ? item.prod === true : item.release === true));
};

export const filterTreeByEnvironment = items => {
    if (!Array.isArray(items)) return [];
    const isProd = isProdEnvironment();
    const predicate = isProd ? item => item.prod === true : item => item.release === true;

    const filterTree = nodes =>
        nodes.reduce((acc, item) => {
            if (item.children && Array.isArray(item.children)) {
                const filteredChildren = filterTree(item.children);
                if (filteredChildren.length > 0) {
                    acc.push({...item, children: filteredChildren});
                }
                return acc;
            }
            if (predicate(item)) acc.push(item);
            return acc;
        }, []);

    return filterTree(items);
};
